import SlackTeamConstants from 'constants/SlackTeamConstants'

class SlackTeamStore extends Marty.Store {
  state = false
  handlers = {
    slackTeamFetched: SlackTeamConstants.FETCH_SLACK_TEAM_FINISHED
  }

  getOrFetchSlackTeam() {
    return this.fetch({
      id: 'getOrFetchSlackTeam',
      locally() {
        if (this.state) {
          return this.state
        }
      },
      remotely() {
        return this.app.actions.SlackTeamActions.fetchSlackTeam()
      }
    })
  }

  slackTeamFetched(users) {
    this.state = users
  }
}

export default SlackTeamStore



// WEBPACK FOOTER //
// ./src/scripts/stores/SlackTeamStore.js